// extracted by mini-css-extract-plugin
export default {"message":"message-vM7mR"};